import { createContext, useContext } from "react";

export const MapaContext = createContext();

export const useMapa = () => {
  const context = useContext(MapaContext);
  if (!context) {
    throw new Error("useMapa deve ser usado dentro de um <MapaProvider>");
  }
  return context;
};
